export default "__VITE_ASSET__Kiizfy1N__"